import { cn } from '@/lib/utils'

interface SectionTitleProps {
  children: React.ReactNode
  size?: 'sm' | 'base' | 'lg'
  align?: 'left' | 'center' | 'right'
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  className?: string
}

const BASE_CLASSES = 'font-bold font-main-font text-text-color mb-8'

const SIZE_CLASSES = {
  sm: 'text-xl md:text-2xl',
  base: 'text-2xl md:text-3xl',
  lg: 'text-3xl md:text-4xl',
} as const

const ALIGN_CLASSES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
} as const

/**
 * SectionTitle - Standardized section heading block
 *
 * Self-contained UI block with inline styles (no UiProvider dependency).
 * Replaces inconsistent h2 styling across frontend sections.
 *
 * Sizes:
 * - sm: Smaller sections (text-xl / text-2xl)
 * - base: Default sections (text-2xl / text-3xl)
 * - lg: Hero/prominent sections (text-3xl / text-4xl)
 */
export function SectionTitle({
  children,
  size = 'base',
  align = 'center',
  as: Tag = 'h2',
  className,
}: SectionTitleProps) {
  return (
    <Tag className={cn(BASE_CLASSES, SIZE_CLASSES[size], ALIGN_CLASSES[align], className)}>
      {children}
    </Tag>
  )
}
